import i18n from "config/i18next";

i18n.addResources("es", "rejectInvoice", {
  preliquidationNumber: "Número de la preliquidación",
  status: "Estado",
  dateOfIssue: "Fecha de generación",
  question: "¿Por qué se va a rechazar la factura?",
  otherPlaceholder: "Ingresá el motivo de rechazo",
  reasonLabel: "Motivo *",
  reasonPlaceholder: "Seleccioná el motivo de rechazo",
  amountReason: "Monto de factura no coincide con el de la preliquidación",
  companyNameReason: "Error en la razón social",
  otherReason: "Otro",
  reject: "Rechazar factura",
});
